module.exports = __webpack_public_path__ + "img/TelefonicaIconsTracking.5c8b2bea.svg";